import React from "react";
import { Icon } from "assets/Icon";
import Tooltip from "components/Tooltip";
import { cn } from "utils/helpers";
import { HStack, IconButton } from "@chakra-ui/react";
import { FiRefreshCw } from "react-icons/fi";

interface FileActionsProps {
	hasErrored?: boolean;
	isPreview?: boolean;
	isUploading?: boolean;
	filePath?: string;
	fileName: string;
	onCancel?: () => void;
	onDelete: () => void;
	onRetry: () => void;
}

/**
 * Provides the different actions available for the files in a list
 * @param param0
 * @returns
 */
export const FileActions: React.FC<FileActionsProps> = ({
	hasErrored = false,
	isPreview = false,
	isUploading = false,
	filePath,
	fileName,
	onDelete,
	onCancel,
	onRetry,
}) => {
	// Uploading → Cancel
	if (isUploading || hasErrored) {
		const cancelUpload = (
			<Tooltip label="Cancel upload">
				<button
					type="button"
					onClick={onCancel}
					className="rounded-full bg-gray-200 p-2 hover:bg-red-200"
				>
					<Icon
						icon="trash"
						size="sm"
					/>
				</button>
			</Tooltip>
		);

		if (isUploading) {
			return cancelUpload;
		}

		return (
			<HStack>
				<Tooltip label="Retry upload">
					<div
						className="cursor-pointer rounded-full bg-red-200 p-2 hover:bg-red-300"
						onClick={onRetry}
					>
						<IconButton
							aria-label="retry failed upload"
							icon={<FiRefreshCw />}
						/>
						retry
					</div>
					{/* <button
					type="button"
					onClick={onRetry}
					className="rounded-full bg-gray-200 p-2 hover:bg-red-200"
				>
					Retry
					<Icon
						icon="upload"
						size="sm"
					/>
				</button> */}
				</Tooltip>
				{cancelUpload}
			</HStack>
		);

		return cancelUpload;
	}

	// Preview mode → Download only
	if (isPreview && filePath) {
		return (
			<Tooltip label="Download file">
				<a
					href={filePath}
					target="_blank"
					rel="noreferrer"
					download={fileName}
					className="rounded-full bg-gray-200 p-2 hover:bg-utility-brand-200"
				>
					<Icon
						icon="download"
						size="sm"
					/>
				</a>
			</Tooltip>
		);
	}

	// Default → Delete
	return (
		<Tooltip
			label={
				<>
					Remove file from submission
					<br />
					(cannot be undone)
				</>
			}
		>
			<button
				type="button"
				onClick={onDelete}
				className={cn("rounded-full bg-gray-200 p-2 hover:bg-red-200")}
			>
				<Icon
					icon="trash"
					size="sm"
				/>
			</button>
		</Tooltip>
	);
};
